const DEV = process.env.NODE_ENV !== 'production';

export const logError = (message, error) => { if (DEV) console.error(message, error); };
export const logWarn = (message, error) => { if (DEV) console.warn(message, error); };
export const isUserCancel = (error) => error?.name === 'AbortError';
